export const isPODomain = () => window.location.href.includes(process.env.REACT_APP_PO_DOMAIN);
export const isCODomain = () => window.location.href.includes(process.env.REACT_APP_CO_DOMAIN);
